import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  InputNumber,
  Popover,
  Row,
  Skeleton,
  Space,
  Spin,
  Table,
  Tooltip,
} from "antd";
import React, { useContext, useEffect } from "react";
import type { ColumnsType } from "antd/es/table";
import { useTheme } from "../../../Context/ThemeContext";

import { dayjs } from "../../../../Utilities/dayjs";
import { handleDecimalValues, Utils } from "../../../../Utilities/Utils";
import { useClient } from "../../../Context/ClientContext";
import { notificationContext } from "../../../Common/Routing/PageRoute";
import JournalService from "../../../Services/JournalService";
import {
  EyeOutlined,
  FacebookFilled,
  LoadingOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import AssetJournalModal from "../AssetJournalModal";
import FixedAssetsServiceNew, {
  AssetStatus_New,
  CalcMethod,
  IChildAssetsListResponse,
  IInvAssetItemDetail,
} from "../../../Services/FixedAssetsServiceNew";
import { ItemAdd_Type } from "../../../Services/ItemsService";
import { useForm } from "antd/es/form/Form";
import FormList from "antd/es/form/FormList";
import { tablePageSizeOptions } from "../../../Common/ThemeSetting";

const Depreciations: React.FC = () => {
  const { themeData } = useTheme();
  const { currentClient, companySettings } = useClient();
  const { openNotification } = useContext(notificationContext);
  const [faChildList, setFAChildList] = React.useState<
    IChildAssetsListResponse[]
  >([]);
  const [searchAsset, setSearchAsset] = React.useState("");
  const [changeStatus, setChangeStatus] = React.useState<number>(
    AssetStatus_New.Active
  );
  const [page, setPage] = React.useState(1);
  const [depForm] = useForm();
  const [pageSize, setPageSize] = React.useState<number>(
    themeData?.tablePageSize ?? 15
  );
  const [journalId, setJournalId] = React.useState<string>();
  const [successRollBack, setSeccesRollBack] = React.useState<boolean>(false);
  const [jrPopoverData, setJrPopOverData] = React.useState<any>([]);
  const [postSuccess, setPostSuccess] = React.useState<boolean>(false);
  const [isDisable, setIsDisable] = React.useState<boolean>(true);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [buttonLoading, setButtonLoading] = React.useState<boolean>(false);
  const [journalRequestList, setjournalRequestList]: any = React.useState([]);
  // const [depreciationtList, setDepreciationtList] = React.useState<any[]>([]);
  const [totalRecords, setTotalRecords] = React.useState<number>(0);
  const [checkedKeys, setCheckedKeys] = React.useState<any[]>([]);
  const [openPopArray, setOpenPopArray] = React.useState<boolean[]>([]);
  const [filterDate, setFilterDate] = React.useState<string>(
    dayjs(companySettings?.period?.to).toISOString()
  );
  const [journalModel, setJournalModel] = React.useState<{
    open: boolean;
    data: any;
  }>({ open: false, data: {} });

  const columns: ColumnsType<IChildAssetsListResponse> = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "id",
      render: (val) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {val}
        </Skeleton>
      ),
    },
    {
      title: "Asset Name",
      dataIndex: "assetRef",
      render: (val) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {val?.name}
        </Skeleton>
      ),
    },
    {
      title: "Purchase / Last Dep. Date",
      dataIndex: "itemDetail",
      align: "center",
      render: (val: IInvAssetItemDetail) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "center" },
          }}
          title={false}
        >
          {val?.depreciationStartDate &&
            dayjs(val.depreciationStartDate).format("DD-MM-YYYY")}
        </Skeleton>
      ),
    },
    {
      title: "Method",
      dataIndex: "depMethod",
      render: (x) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
          }}
          title={false}
        >
          {x === CalcMethod.WrittenDownValue
            ? "Written Down value"
            : x === CalcMethod.StraightLine
            ? "Straight Line"
            : ""}
        </Skeleton>
      ),
    },
    {
      title: "Rate/Year",
      dataIndex: "depRate",
      align: "center",
      render: (x: number, record: IChildAssetsListResponse) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "center" },
          }}
          title={false}
        >
          {record.depMethod === CalcMethod.StraightLine
            ? `${record?.lifeCycleDuration} year(s)`
            : `${x} %`}
        </Skeleton>
      ),
    },

    {
      title: "Quantity",
      dataIndex: "qty",
      align: "center",
      render: (x) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "end" },
          }}
          title={false}
        >
          {x}
        </Skeleton>
      ),
    },
    {
      title: "Purchase Price",
      dataIndex: "price",
      align: "right",
      render: (x) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "end" },
          }}
          title={false}
        >
          {Utils.getFormattedCurrency(x)}
        </Skeleton>
      ),
    },

    {
      title: "Accumulated Dep.",
      dataIndex: "accumulatedDepreciation",
      align: "right",
      render: (x) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "end" },
          }}
          title={false}
        >
          {Utils.getFormattedCurrency(x)}
        </Skeleton>
      ),
    },
    {
      title: "Residual Value",
      dataIndex: "itemDetail",
      align: "right",
      render: (x: IInvAssetItemDetail) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "end" },
          }}
          title={false}
        >
          {x?.residualValue && Utils.getFormattedCurrency(x?.residualValue)}
        </Skeleton>
      ),
    },
    {
      title: (
        <>
          <span>Depreciation</span> &nbsp;
          <Tooltip title="This is calculated depreciation amount according to method and rate given, you can provide your own also">
            <EyeOutlined />
          </Tooltip>
        </>
      ),
      dataIndex: "depAmount",
      align: "right",
      render: (x: number, record: IChildAssetsListResponse) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "end" },
          }}
          title={false}
        >
          <Form.Item name={record.id} style={{ marginBottom: 2 }}>
            <InputNumber
              style={{ width: 150 }}
              value={x}
              precision={2}
              type="number"
              onKeyPress={handleDecimalValues}
              min={0}
              step={0.1}
            />
          </Form.Item>
          {/* {Utils.getFormattedCurrency(x)} */}
        </Skeleton>
      ),
    },
    {
      title: "Net Book Value",
      dataIndex: "currentWDValue",
      align: "right",
      render: (x) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "end" },
          }}
          title={false}
        >
          {Utils.getFormattedCurrency(x)}
        </Skeleton>
      ),
    },
  ];

  // Api Asset Items Get List
  const getList = async (
    clientId: string,
    start: number,
    length: number,
    sortCol: any,
    sortDir: any,
    search: string,
    status: AssetStatus_New,
    type: ItemAdd_Type,
    assetItemId?: string,
    tillDate?: string
  ) => {
    await FixedAssetsServiceNew.getChildAssetsList(
      clientId,
      start,
      length,
      sortCol,
      sortDir,
      search,
      status,
      type,
      assetItemId,
      tillDate
    )
      .then(({ result }) => {
        if (result?.items?.length > 0) {
          setFAChildList(
            result?.items?.map((e, index: number) => {
              depForm.setFieldValue(e.id, e.depAmount);
              return {
                ...e,
                sno: index + 1,
                key: index + 1,
              };
            }) || []
          );
          setTotalRecords(result?.totalRecords);
          setIsDisable(false);
        } else if (result.items.length === 0) {
          setFAChildList([]);
          setTotalRecords(result?.totalRecords);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    getList(
      currentClient?.id!,
      (page - 1) * pageSize,
      pageSize,
      undefined,
      undefined,
      searchAsset,
      changeStatus,
      ItemAdd_Type.All,
      "",
      dayjs(filterDate).endOf("day").toISOString()
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize, filterDate, postSuccess, successRollBack]);

  // --------Journal Get API ---------
  useEffect(() => {
    if (journalId) {
      setButtonLoading(true);
      JournalService.getJournalData(currentClient?.id!, journalId)
        .then((res: any) => {
          const jnl = res?.result?.journal?.items;
          if (res?.status) {
            setJrPopOverData(jnl);
            setButtonLoading(false);
          } else setButtonLoading(false);
        })
        .catch((ex: any) => {
          openNotification("error", ex.message);
          setButtonLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [journalId]);

  const postJournal = () => {
    setLoading(true);
    var fieldsValue = depForm.getFieldsValue();
    let newValues = faChildList.map((asst) => ({
      ...asst,
      depAmount: fieldsValue[asst.id],
    }));

    FixedAssetsServiceNew.PostDepreciationEntry(
      currentClient?.id!,
      dayjs(filterDate).endOf("day").toISOString(),
      newValues
    )
      .then((val) => {
        if (val.status) {
          openNotification("success", "Voucher submitted successfully.");
          setLoading(false);
          setPostSuccess(true);
        } else {
          openNotification("error", val?.errors);
          setLoading(false);
        }
      })
      .catch((er) => {
        openNotification("error", er.message);
        setLoading(false);
      });
  };

  return (
    <div>
      <Spin
        indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />}
        spinning={loading}
      >
        <Card
          size="small"
          className="TableCard"
          style={{
            // width: "97%",
            // marginLeft: "16px",
            marginTop: 35,
            // padding: "18px 0px 0px 0px",
            boxShadow: "0px 0px 10px 0px #96A1C84D",
          }}
        >
          <Space
            size={12}
            style={{
              // marginTop: 10,
              padding: "0px 0px 3px 0px",
              display: "flex",
              justifyContent: "end",
            }}
          >
            <Button type="primary" disabled={isDisable} onClick={postJournal}>
              Post Journal
            </Button>
            <div>Depreciation to</div>
            <DatePicker
              disabledDate={(current) =>
                current < dayjs("1900-01-01", "YYYY-MM-DD").add(-1, "day")
              }
              allowClear={false}
              defaultValue={dayjs(filterDate)}
              format={"DD/MM/YYYY"}
              onChange={(e) => {
                e && setFilterDate(dayjs(e).toISOString());
              }}
            />
          </Space>
          <Form form={depForm} name="depForm">
            <Table
              className={`Tabel-style table-${
                themeData?.componentSize ?? "middle"
              }`}
              columns={columns}
              dataSource={
                loading
                  ? (Array.from({ length: pageSize }, (_, index) => ({
                      key: `loading-${index}`,
                    })) as IChildAssetsListResponse[])
                  : faChildList
              }
              pagination={{
                total: totalRecords,
                current: page,
                pageSize: pageSize,
                showSizeChanger: true,
                onChange: (page: number, pageSize: number) => {
                  setPage(page);
                  setPageSize(pageSize);
                },
                pageSizeOptions: tablePageSizeOptions,
              }}
              size="small"
              style={{ overflowX: "auto" }}
            />
          </Form>
        </Card>
      </Spin>
      {journalModel.open && (
        <AssetJournalModal
          modal={journalModel}
          setModal={setJournalModel}
          success={successRollBack}
          setSuccess={setSeccesRollBack}
          isCustomJrnls={true}
        />
      )}
    </div>
  );
};
export default Depreciations;
